import React from 'react';


export const About = () => {
  return (
    <main className="About">
      <div className="aboutCard">
        <h2>👋 Welcome to Social Media</h2>
        <p>
          Our platform lets you share your daily life, thoughts, and future plans with the world.
        </p>
        <ul>
          <li>📅 Post your daily activities</li>
          <li>🧠 Share what’s on your mind</li>
          <li>📝 Edit or delete posts anytime</li>
          <li>📈 Reflect on your journey by looking back at your thoughts  </li>
          <li>🌟 A perfect space for personal journaling and goal-setting  </li>
        </ul>
        <p>
          Whether you're documenting your journey, sharing ideas, or just expressing yourself, this is your space. Start posting and let your voice be heard!
        </p>
      </div>
    </main>
  );
};

